import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { createStore } from "redux";
import { rootReducer } from "./reducers";
import { devToolsEnhancer } from "redux-devtools-extension";

const store = createStore(
  rootReducer /* preloadedState, */,
  devToolsEnhancer({ name: "root" })
);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
